import React from 'react';
import './ModuleOverviewPartsStepper.css';

/**
 * Experimental chevron parts stepper for module overview (mobile).
 * Removable as a unit - see overviewLayoutExperiment.js.
 */
const ModuleOverviewPartsStepper = ({
  sections,
  activeSectionId,
  isStepUnlocked,
  onStepSelect,
}) => {
  if (!sections?.length) return null;

  return (
    <nav className="module-parts-stepper" aria-label="Module parts">
      <ol className="module-parts-stepper__list">
        {sections.map((section, index) => {
          const isActive = activeSectionId === section.id;
          const isLocked = !isStepUnlocked(section, index);
          const isFirst = index === 0;
          const isLast = index === sections.length - 1;
          const labelId = `module-parts-stepper-label-${section.id}`;
          const chevronClassName = [
            'module-parts-stepper__chevron',
            isActive ? 'module-parts-stepper__chevron--active' : '',
            isFirst ? 'module-parts-stepper__chevron--first' : '',
            isLast ? 'module-parts-stepper__chevron--last' : '',
          ].filter(Boolean).join(' ');

          const content = (
            <>
              <span className="module-parts-stepper__title" id={labelId}>
                Part {section.stepNumber}
              </span>
              <span className="module-parts-stepper__label">{section.shortLabel}</span>
            </>
          );

          return (
            <li
              key={section.id}
              className={`module-parts-stepper__item${isActive ? ' module-parts-stepper__item--active' : ''}`}
            >
              {isLocked ? (
                <span
                  className={chevronClassName}
                  aria-labelledby={labelId}
                  aria-disabled="true"
                  title={`Complete Part ${index} first`}
                >
                  {content}
                </span>
              ) : (
                <button
                  type="button"
                  className={chevronClassName}
                  aria-labelledby={labelId}
                  aria-current={isActive ? 'step' : undefined}
                  onClick={() => onStepSelect(section, index)}
                >
                  {content}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default ModuleOverviewPartsStepper;
